import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import ui from '@alpinejs/ui';
import anchor from '@alpinejs/anchor'
import * as Sentry from "@sentry/browser";
import '@github/relative-time-element';
import '../../vendor/wire-elements/pro/resources/js/overlay-component.js'
import tippy from 'tippy.js';

Alpine.plugin(ui);
Alpine.plugin(anchor);

Sentry.init({
    dsn: window.sentry_dsn,
    release: window.sentry_release,
    environment: window.sentry_environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: window.sentry_traces_sample_rate,
});

Alpine.magic('tooltip', el => (message, timeout = 2000) => {
    let instance = tippy(el, { content: message, trigger: 'manual' })

    instance.show()

    setTimeout(() => {
        instance.hide()

        setTimeout(() => instance.destroy(), 150)
    }, timeout)
})

Alpine.directive('tooltip', (el, { expression }) => {
    tippy(el, { content: expression })
})

Livewire.start();
